import { ReactElement, useMemo, useCallback } from 'react';

import { useHistory } from 'react-router-dom';

import * as S from './styles';

function ILAB(): ReactElement {
  const router = useHistory();

  const handleGoILABOption = useCallback(
    (ILABCategory: string) => {
      router.push(`/ilab/${ILABCategory}`);
    },
    [router],
  );

  const ILABMenuMemo = useMemo(() => {
    const ILABMenuOptions = [
      { label: 'MET - LIBRARY', value: 'methods' },
      { label: 'EX - LIBRARY', value: 'exercises' },
      { label: 'TRAINING STORE', value: 'training-store' },
      { label: 'SIMBOLOGIA', value: 'symbology' },
    ];

    return ILABMenuOptions.map(({ label, value }) => (
      <S.ILABMenuItem key={label}>
        <S.ILABMenuLink onClick={() => handleGoILABOption(value)}>
          {label} <span>{'>'}</span>
        </S.ILABMenuLink>
      </S.ILABMenuItem>
    ));
  }, [handleGoILABOption]);

  return (
    <S.Container>
      <S.ILABMenu>{ILABMenuMemo}</S.ILABMenu>
    </S.Container>
  );
}

export default ILAB;
